import React from 'react';
import { CardHeader } from '@europrocurement/flexy-components';
import { Box, Typography } from '@mui/material';
import RequiredDocumentsTotal from './RequiredDocumentsTotal';

export type RequiredDocumentsHeadingProps = {
    missingDocumentsCount: number;
    totalCount: number;
};

const RequiredDocumentsHeading: React.FunctionComponent<RequiredDocumentsHeadingProps> = function (
    props,
) {
    const { missingDocumentsCount, totalCount } = props;

    return (
        <CardHeader
            title="Documents requis"
            titleSx={{
                fontSize: '20px',
                lineHeight: '28px',
            }}
            border={false}
            headerSx={{
                paddingX: '32px',
                paddingBottom: '1em',
            }}
            sx={{
                paddingX: 0,
            }}
            childrenSx={{ paddingX: 0 }}
        >
            <Box>
                {totalCount > 0 && (
                    <RequiredDocumentsTotal
                        missingDocumentsCount={missingDocumentsCount}
                        totalCount={totalCount}
                        additionnalText="documents"
                    />
                )}

                <Typography
                    component="p"
                    variant="l2dbodyxs"
                    sx={{ marginY: '8px', color: 'text.gris50' }}
                >
                    Formats : .pdf .doc .jpg .xls - Poids maximum : 10Mo
                </Typography>
            </Box>
        </CardHeader>
    );
};

export default RequiredDocumentsHeading;
